import React from 'react';
import CreateTraitDetailsSnpsDialog from './trait-details-snps-dialogs/CreateTraitDetailsSnpsDialog';
import DeleteTraitDetailSnpsDialog from './trait-details-snps-dialogs/DeleteTraitDetailsSnpsDialog';

function TraitDetailsSnpsDialogs() {
  return (
    <>
      <DeleteTraitDetailSnpsDialog />
      <CreateTraitDetailsSnpsDialog />
    </>
  );
}

export default TraitDetailsSnpsDialogs;
